import { useMemo } from "react";
import { chartData } from "views/components/visualizations/ChartData";
import useUserDateTime from "hooks/useUserDateTime";
import useMapKeys from "views/components/visualizations/useMapKeys";
const useChartData = (rows, config) => {
  const { formatTime } = useUserDateTime();
  const mapKeys = useMapKeys();
  return useMemo(
    () => chartData(rows, {
      formatTime,
      mapKeys,
      ...config
    }),
    [config, formatTime, mapKeys, rows]
  );
};
export default useChartData;
